//  Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component } from '@angular/core';

@Component({
    selector: 'app-cigent-capabilities',
    templateUrl: './cigent-capabilities.component.html',
    styleUrls: ['./cigent-capabilities.component.scss'],
    standalone: false
})
export class CigentCapabilitiesComponent {}
